import { Modal } from 'react-bootstrap';
import { KeVatTuContextProvider } from './context';
import FormKeVatTu from './FormKeVatTu';

type Props = {
	open: boolean;
	onClose: () => void;
	phieuDieuTri?: any;
	onSave?: () => void;
	itemEdit?: any;
};

const ChiDinhVatTu = ({ open, onClose, phieuDieuTri, onSave, itemEdit }: Props) => {
	return (
		<Modal
			className="page-full"
			fullscreen
			dialogClassName="h-modal"
			size="xl"
			show={open}
			animation={false}
			centered
			backdropClassName="spaces top-50"
		>
			<KeVatTuContextProvider phieuDieuTri={itemEdit ? {
				id: itemEdit?.treatmentSheetId,
				prescriptionDate: itemEdit?.treatmentSheetCreatedDate
			} : phieuDieuTri}>
				<FormKeVatTu onClose={onClose} onSave={onSave} itemEdit={itemEdit} />
			</KeVatTuContextProvider>
		</Modal>
	);
};

export default ChiDinhVatTu;
